export enum PaymentMethod {
    EXPRESS = 'EXPRESS',
    CREDIT_CARD = 'CREDIT_CARD',
    BIZUM = 'BIZUM',
    BANK_ACCOUNT = 'BANK_ACCOUNT',
    APPLE = 'APPLE',
    GOOGLE = 'GOOGLE',
}

export interface PaymentMethodOrder {
    express?: number;
    credit_card: number;
    bizum?: number;
    bank_account: number;
    apple?: number;
    google?: number;
    others?: number;
}